import { Component } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-registration-edit',
  templateUrl: './registration-edit.component.html',
  styleUrls: ['./registration-edit.component.scss']
})
export class RegistrationEditComponent {
  user_id: any;
  mem_id: any;
  event_id: any;
  reg_id: any;

  constructor(
    private service: ServicesService,
    private PlatformLocation: PlatformLocation,
    private router: Router,
    private route: ActivatedRoute
  ) {

    history.pushState(null, '', location.href);
    this.PlatformLocation.onPopState(() => {
      history.pushState(null, '', location.href);
    })
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.mem_id = params.get('mem_id');
      this.event_id = params.get('event_id');
      this.user_id = params.get('user_id');
      this.reg_id = params.get('reg_id');

      console.log(this.event_id);
      console.log(this.mem_id);
      console.log(this.reg_id);
      console.log(this.user_id);

    });
  }

}
